export function downloadPdf(bytes: Uint8Array, fileName: string) {
  const blob = new Blob([new Uint8Array(bytes)], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}

export function openPdfInNewTab(bytes: Uint8Array) {
  const blob = new Blob([new Uint8Array(bytes)], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

/**
 * Opens the browser's native print dialog for the PDF without leaving the page.
 * The PDF loads in an off-screen iframe; if the browser refuses to print it
 * (some PDF viewers block `print()` on embedded documents) we fall back to a new tab.
 */
export function printPdf(bytes: Uint8Array) {
  const blob = new Blob([new Uint8Array(bytes)], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  iframe.tabIndex = -1;
  iframe.className = "fixed -left-[9999px] top-0 h-px w-px border-0";
  iframe.src = url;

  const cleanup = () => {
    iframe.remove();
    URL.revokeObjectURL(url);
  };

  iframe.onload = () => {
    try {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
      // Keep the document alive while the print dialog is open.
      window.setTimeout(cleanup, 5 * 60_000);
    } catch {
      cleanup();
      openPdfInNewTab(bytes);
    }
  };

  document.body.appendChild(iframe);
}
